import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudUploadAlt } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";

const NoBillUploaded = () => {
  const navigate = useNavigate();

  const redirectToRoutes = async (route) => {
    navigate(route);
  };
  return (
    <>
      <div className="absolute inset-0 bg-black bg-opacity-50 flex justify-center items-center w-full h-full z-50">
        <div className="bg-white p-8 rounded-lg shadow-lg text-center max-w-md">
          <div className="flex justify-center mb-4">
            <div className="absolute inset-0 bg-black bg-opacity-50 flex justify-center items-center w-full h-full z-50">
              <div className="bg-white p-8 rounded-lg shadow-lg text-center max-w-md">
                <div className="flex justify-center mb-4">
                  <FontAwesomeIcon
                    icon={faCloudUploadAlt} // FontAwesome upload icon
                    className="text-[#067C4E] text-5xl"
                  />
                </div>
                <p className="text-xl font-semibold text-gray-800 mb-2">
                  No Bills Uploaded Yet!
                </p>
                <p className="text-sm text-gray-600 mb-6">
                  To get started, upload your electricity bills and explore the
                  dashboard's features. Need help? Watch our demo video for a
                  quick walkthrough.
                </p>
                <div className="flex flex-col gap-4">
                  <button
                    onClick={() => redirectToRoutes("/upload")} // Replace with the actual route to the upload page
                    className="text-center rounded-[10px] p-[10px] text-[16px] font-medium leading-[24px] text-white bg-[#067C4E] h-[44px] w-full hover:bg-[#05633D]"
                  >
                    Upload Bills
                  </button>
                  <button
                    onClick={() => redirectToRoutes("/demo")} // Replace with the actual route to the demo video
                    className="text-center rounded-[10px] p-[10px] text-[16px] font-medium leading-[24px] text-[#067C4E] bg-white border border-[#067C4E] h-[44px] w-full hover:bg-[#E2F5EC]"
                  >
                    Watch Demo Video
                  </button>
                </div>
              </div>
            </div>
          </div>
          <p className="text-xl font-semibold text-gray-800 mb-2">
            No Bills Uploaded Yet!
          </p>
          <p className="text-sm text-gray-600 mb-6">
            To get started, upload your electricity bills and explore the
            dashboard's features. Need help? Watch our demo video for a quick
            walkthrough.
          </p>
          <div className="flex flex-col gap-4">
            <button
              onClick={() => navigate("/upload")}
              className="text-center rounded-[10px] p-[10px] text-[16px] font-medium leading-[24px] text-white bg-[#067C4E] h-[44px] w-full hover:bg-[#05633D]"
            >
              Upload Bills
            </button>
            <button
              onClick={() => navigate("/demo-video")} // Replace with the actual route to the demo video
              className="text-center rounded-[10px] p-[10px] text-[16px] font-medium leading-[24px] text-[#067C4E] bg-white border border-[#067C4E] h-[44px] w-full hover:bg-[#E2F5EC]"
            >
              Watch Demo Video
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default NoBillUploaded;
